var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStopMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4839 12.0489C10.2916 12.1911 10.1265 12.3083 10 12.3962C9.87352 12.3083 9.70841 12.1911 9.51611 12.0489C9.05703 11.7092 8.44711 11.2298 7.83929 10.6683C7.22934 10.1048 6.63437 9.47032 6.19521 8.82205C5.75111 8.16649 5.5 7.54612 5.5 7C5.5 4.51472 7.51472 2.5 10 2.5C12.4853 2.5 14.5 4.51472 14.5 7C14.5 7.54612 14.2489 8.16649 13.8048 8.82205C13.3656 9.47032 12.7707 10.1048 12.1607 10.6683C11.5529 11.2298 10.943 11.7092 10.4839 12.0489Z",
    stroke: "#6E7882"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7C8.5 6.17157 9.17157 5.5 10 5.5C10.8284 5.5 11.5 6.17157 11.5 7C11.5 7.82843 10.8284 8.5 10 8.5C9.17157 8.5 8.5 7.82843 8.5 7Z",
    stroke: "#6E7882"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16C2.5 15.1716 3.17157 14.5 4 14.5H16C16.8284 14.5 17.5 15.1716 17.5 16C17.5 16.8284 16.8284 17.5 16 17.5H4C3.17157 17.5 2.5 16.8284 2.5 16Z",
    stroke: "#6E7882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopMarker);
export default __webpack_public_path__ + "static/media/icon-stop-marker.2b5844a25c2ba201ca565ea4a43bd4db.svg";
export { ForwardRef as ReactComponent };